var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox',{attrs:{"checked":_vm.booleanValue,"plain":""},on:{"input":function($event){return _vm.$emit('input', $event ? 'Yes' : 'No')}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }